/**
 * 회원유형변경 > 수발주자 > 기종선택 모달 (BS self-contained)
 *
 * 호출:
 *   $j.Ui.BS.open({ target: '$j.F.Member.ModalCarOption' });
 *
 * 적용 결과는 자체적으로 location.reload() 까지 처리하므로 콜백 불필요.
 */
import Util from '../../../Common/Util';
export default class CarOption {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
    }

    /**
     * 회원유형변경 진입 — 발주자만 수발주자로 전환할 수 있다. 이미 전환됐으면 안내만 하고,
     * 아니면 이 기종선택 모달(BS)을 연다. 알림·전체메뉴·내정보(my) 세 곳이 공유하는 단일 진입점.
     * (구 public/js/mobile.js 의 전역 changeDriverType)
     */
    changeDriverType() {
        if (MEMBER['mem_driver_type'] != '발주자') {
            Util.swalert('이미 수발주자로 변경되었습니다.');
            return;
        }
        $j.Ui.BS.open({ target: '$j.F.Member.ModalCarOption', fixedHeight: true });
    }

    init() {
        // skeleton 동기 렌더링
        this.parent.setTitle('장비등록');
        $('#' + this.id).html(this.skeletonHtml());
        this._setupCarSelect();
        this._bindHandlers();
    }

    skeletonHtml() {
        return `
<div class="equip_wrap">
    <div class="equip_select">
        <p>1. 장비 기종을 선택 주세요</p>
        <div class="select_box">
            <select id="car-search-cartype"></select>
            <i class="fas fa-angle-down"></i>
        </div>
    </div>

    <div class="equip_select">
        <p>2. 장비유형 및 톤수(T)를 선택해 주세요</p>
        <div class="select_box">
            <select id="car-search-depth1"></select>
            <i class="fas fa-angle-down"></i>
        </div>
        <div class="select_box">
            <select id="car-search-depth2"></select>
            <i class="fas fa-angle-down"></i>
        </div>
    </div>

    <div class="equip_select">
        <p>3. 장비 전고를 선택해 주세요</p>
        <div class="select_box">
            <select id="car-search-jungo"></select>
            <i class="fas fa-angle-down"></i>
        </div>
    </div>

    <div class="equip_select">
        <p>4. 장비 옵션을 선택해 주세요</p>
        <div class="check_box" id="car-search-option-area"></div>
    </div>

    <div class="equip_select">
        <p>5. 차량번호를 입력해 주세요</p>
        <div class="select_box">
            <input type="text" id="car-platenumber" placeholder="차량번호를 입력해 주세요">
        </div>
    </div>

    <div class="result_box">
        <button class="on btn-apply">등록하기</button>
    </div>
</div>`;
    }

    destroy() {
        $('#' + this.id).off();
    }

    _setupCarSelect() {
        $j.F.CarSelect.initialize({
            idList: {
                car_type: 'car-search-cartype',
                depth1:   'car-search-depth1',
                depth2:   'car-search-depth2',
                jungo:    'car-search-jungo',
                option:   'car-search-option-area',
            },
        });
    }

    _bindHandlers() {
        const self = this;
        $('#' + this.id).on('click.carOption', '.btn-apply', function () {
            self.apply();
        });
    }

    apply() {
        const $sel = $j.F.CarSelect;
        const data = {
            car_type:        $sel.getCarType(),
            depth1:          $sel.getDepth1(),
            depth2:          $sel.getDepth2(),
            jungo:           $sel.getJungo(),
            option:          $sel.getOption(),
            car_platenumber: $('#car-platenumber').val(),
        };

        if (!data.car_type || !data.depth1 || !data.depth2 || (data.car_type != '리프트' && !data.jungo) || !data.car_platenumber) {
            $j.Common.Util.tsalert('warning', '필수항목을 모두 입력해주세요.');
            return;
        }

        const self = this;
        $.ajax({
            type: 'post',
            url:  '/m/ajax/member/driver-type2',
            data,
            success(r) {
                if (!r.result) {
                    $j.Common.Util.tsalert('warning', r.msg);
                    return;
                }
                self.parent.close();
                Util.swalert('처리되었습니다.', function () {
                    location.reload();
                });
            },
        });
    }
}
